import { QueryClient } from '@tanstack/react-query';
import { create } from 'zustand';

export enum UserRole {
	ADMIN = 1,
	USER = 2,
}

export interface Project {
	name: string;
	id: number;
	link: string;
	games: {
		name: string;
		id: number;
		serverId: number;
		platform: 'test' | 'wechat' | 'douyin';
		description: string;
	}[];

	// 物理服
	servers: {
		name: string;
		id: number;
	}[];
}

export interface User {
	_id: number;
	name: string;
	createdAt: number;
	role: UserRole;
	// 权限
	permissions: { projectId: number; gameIds: number[] }[];
	projects: Project[];
}

interface Admin {
	queryClient: QueryClient;
	user: User | undefined;
	setUser: (user: User) => void;
	clearUser: () => void;
}

export const useAdmin = create<Admin>((set, get) => ({
	queryClient: new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 1000 * 60 * 5,
			},
		},
	}),
	user: undefined,
	setUser: user => set({ user }),
	clearUser: () => {
		set({ user: undefined });
		get().queryClient.removeQueries({ queryKey: ['user'] });
	},
}));
